
import * as React from 'react';
import { Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import MajorSubject from './majorsubject';
import MinorSubject from './minorsubject';
import { useEffect, useState } from 'react';
import { fetchSubjectbyStudentID } from "../../api/studentDetails";

function SubjectDetails({ courseId }) {
    const [isMajorSaved, setIsMajorSaved] = useState(false);
    const [activeTab, setActiveTab] = useState("major");
    const [majorSubjects, setMajorSubjects] = useState([]);
    const [hasExistingPreferences, setHasExistingPreferences] = useState(false);
    const [studentPreferences, setStudentPreferences] = useState(null);
    
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const studentId = typeof window !== "undefined" ? localStorage.getItem("id") : null;

    useEffect(() => {
        const checkExistingPreferences = async () => {
            try {
                const response = await fetchSubjectbyStudentID(token, studentId, courseId);
                console.log("Subject Preferences Response:", response.data);
                
                if (response.data && 
                    (response.data.majorDisciplines?.length > 0 || 
                     response.data.otherSubjectCategories?.length > 0)) {
                    setHasExistingPreferences(true);
                    setStudentPreferences(response.data);
                    setActiveTab("minor");
                    setIsMajorSaved(true); 
                    
                    if (response.data.majorDisciplines) {
                        const majors = response.data.majorDisciplines.map(major => ({
                            preference: major.otherSubjectCategories.id

                        }));
                        setMajorSubjects(majors);
                    }
                }
            } catch (error) {
                console.error("Error checking existing preferences:", error);
            }
        };
        
        if (courseId && studentId) {
            checkExistingPreferences();
        }
    }, [token, studentId, courseId]);

    const handleTabSelect = (key) => {
        if (key === "minor" && !isMajorSaved && !hasExistingPreferences) {
            alert("Please submit Major Subject preferences first.");
            return;
        }
        setActiveTab(key);
    };

    const handleMajorSave = (majorData) => {
        if (!majorData || majorData.length === 0) {
            alert("No major subjects selected.");
            return;
        }
        setMajorSubjects(majorData);
        setIsMajorSaved(true);
        setActiveTab("minor");
    };

    return (
        <Row className='mt-4'>
            <Col>
                <Card>
                    <Card.Body>
                        <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
                            <Tab 
                                eventKey="major" 
                                title="Major" 
                                disabled={hasExistingPreferences}
                            >
                                {!hasExistingPreferences && (
                                    <MajorSubject 
                                        onSave={handleMajorSave} 
                                        courseId={courseId} 
                                    />
                                )}
                            </Tab>
                            <Tab 
                                eventKey="minor" 
                                title="Minor" 
                                disabled={!isMajorSaved && !hasExistingPreferences}
                            >
                                <MinorSubject 
                                    courseId={courseId} 
                                    majorSubjects={majorSubjects} 
                                    existingPreferences={studentPreferences}
                                />
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}

export default SubjectDetails;